var exports = {
  "u": "x2b2fbebb--ff8397--spinner",
};

module.exports = exports;
